export enum EmploymentPosition {
  SDE = "SDE",
  HR = "HR",
  PM = "PM",
  ACCOUNTANT = "ACCOUNTANT",
  CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
  CEO = "CEO",
  CO_FOUNDER = "CO_FOUNDER",
  CTO = "CTO"
}

export enum EmploymentPositionLevel {
  STAFF = "STAFF",
  SENIOR = "SENIOR",
  JUNIOR = "JUNIOR",
  INTERN = "INTERN"
}
export enum EmploymentType {
  EMPLOYEE = "EMPLOYEE",
  STAFF = "STAFF",
  ADMIN = "ADMIN"
}

export enum EducationDegree {
  HIGH_SCHOOL = "HIGH_SCHOOL",
  BACHELORS = "BACHELORS",
  MASTERS = "MASTERS",
  ASSOCIATE = "ASSOCIATE",
  PHD = "PHD"
}

export enum EmploymentDuration {
  FULL_TIME = "FULL_TIME",
  PART_TIME = "PART_TIME"
}

export enum PermissionRole {
  EMPLOYEE = "EMPLOYEE",
  STAFF = "STAFF",
  ADMIN = "ADMIN",
  ANONYMOUS = "ANONYMOUS",
  MEMBER = "MEMBER"
}

export enum EmployeeResignReasons {
  AT_WILL = "AT_WILL",
  PERFORMANCE = "PERFORMANCE",
  BUDGET_CUT = "BUDGET_CUT"
}

export enum EmployeeHireStatus {
  ON_HOLD = "ON_HOLD",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  BLOCKED = "BLOCKED"
}

export interface Address {
  country: string;
  province: string;
  district: string;
  sector: string;
  cell: string;
  village: string;
}

export interface AdditionalEmployeeInfo {
  linkedInUrl: string;
  portfolioUrl: string;
  schoolName: string;
  degree: EducationDegree;
  concentration: string;
  githubUrl: string;
}

export interface HiredEmployeeInfo {
  avatar: string;
  positions: EmploymentPosition[];
  positionLevel: EmploymentPositionLevel;
  employmentType: EmploymentType;
  employmentDuration: EmploymentDuration;
  dateOfBirth: Date;
  hireDate: Date;
  rehireDate?: Date;
  resignDate?: Date;
  resignReason?: EmployeeResignReasons;
  address: Address;
  hireStatus: EmployeeHireStatus;
  isVerified: boolean;
}

export interface Employee {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role: PermissionRole;
  alias: string;
  additionalEmployeeInfo: AdditionalEmployeeInfo;
  hiredEmployeeInfo: HiredEmployeeInfo;
}

export interface GetEmployeeListResponse {
  adminGetAllEmployees: Employee[];
}

export interface GetEmployeeInfoResponse {
  getEmployeeById: Employee;
}

export interface adminGetEmployeeListRequest {
  email?: string;
  phoneNumber?: string;
  employeeId?: string;
  alias?: string;
  firstName?: string;
  lastName?: string;
}

export interface CreateEmployeeFormData {
  firstName: string;
  lastName: string;
  avatar: string;
  positions: EmploymentPosition[];
  positionLevel: EmploymentPositionLevel;
  employmentType: EmploymentType;
  employmentDuration: EmploymentDuration;
  dateOfBirth: Date;
  hireDate: Date;
  phoneNumber: string;
  role: PermissionRole;
  country: string;
  province: string;
  district: string;
  sector: string;
  cell: string;
  village: string;
}

export interface CreateHiredEmployeeRequestInfo {
  avatar: string;
  positions: EmploymentPosition[];
  positionLevel: EmploymentPositionLevel;
  employmentType: EmploymentType;
  employmentDuration: EmploymentDuration;
  dateOfBirth: string;
  hireDate: string;
  address: Address;
}

export interface CreateEmployeeRequest {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  role: PermissionRole;
  hiredEmployeeInfo: CreateHiredEmployeeRequestInfo;
  additionalEmployeeInfo?: AdditionalEmployeeInfo;
}

export interface EditEmployeeFormData {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  role: PermissionRole;
  avatar: string;
  positions: EmploymentPosition[];
  positionLevel: EmploymentPositionLevel;
  employmentType: EmploymentType;
  employmentDuration: EmploymentDuration;
  dateOfBirth: Date;
  hireDate: Date;
  rehireDate?: Date;
  resignDate?: Date;
  resignReason?: EmployeeResignReasons | null;
  country: string;
  province: string;
  district: string;
  sector: string;
  cell: string;
  village: string;
  hireStatus: EmployeeHireStatus;
}

export interface EditHiredEmployeeRequestInfo {
  avatar: string;
  positions: EmploymentPosition[];
  positionLevel: EmploymentPositionLevel;
  employmentType: EmploymentType;
  employmentDuration: EmploymentDuration;
  dateOfBirth: string;
  hireDate: string;
  rehireDate?: string;
  resignDate?: string;
  resignReason?: EmployeeResignReasons | null;
  address: Address;
  hireStatus: EmployeeHireStatus;
  isVerified: boolean;
}

export interface EditEmployeeRequest {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  role: PermissionRole;
  hiredEmployeeInfo: EditHiredEmployeeRequestInfo;
  additionalEmployeeInfo?: AdditionalEmployeeInfo;
}

export interface CreateEmployeeResponse {
  addEmployee: Employee;
}

export interface EditEmployeeResponse {
  adminUpdateEmployee: Employee;
}

export interface SetPasswordRequest {
  email: string;
  password: string;
  employeeId: string;
}

export interface SetPasswordFormData {
  email: string;
  password: string;
  confirmPassword: string;
}

export interface SetPasswordresponse {
  setEmployeePassword: Employee;
}
